<template>
  <main class="content">
    <!-- <div v-clipboard:copy="JSON.stringify(meetingInfo)"  v-clipboard:success="copySuccess">会议信息</div>
    <div v-clipboard:copy="JSON.stringify(userInfo)"  v-clipboard:success="copySuccess">个人信息</div> -->
    <section>
      <CreateCard
        prePath="intro"
        :roleType="roleType"
        @toCreate="toCreate"
        @toTemplateCenter="toTemplateCenter"
      />
    </section>
    <section class="part template" aria-labelledby="intro-template-title">
      <!-- <div @click="$router.push({name: 'timer'})">计时</div> -->
      <header id="intro-template-title" class="title">
        <h2>热门模版</h2><SeoLink class="more-link" :to="{ name: 'templateCenter' }" :guard="handleTemplateCenterLink">查看更多></SeoLink>
      </header>
      <SeoLink
        v-for="(item, index) in templateLists"
        :key="index"
        class="template-item"
        :to="templateDetailRoute(item)"
        :guard="() => handleTemplateDetailLink(item)"
      >
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220420/0170f928bd0041c933ed63be34cfea48.png"
          alt=""
        />
        <div>
          <p class="intro">
            {{ item.title }}
          </p>
          <p class="desc">共{{ item.count }}题丨{{ item.joined }}人已选用</p>
        </div>
      </SeoLink>
    </section>
    <section class="part fun" aria-labelledby="intro-feature-title">
      <header id="intro-feature-title" class="title"><h2>核心功能</h2></header>
      <article v-for="(item, index) in funLists" :key="index" class="fun-item">
        <div class="intro"><span></span>{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </article>
    </section>
    <footer class="login-btn">
      <span v-if="isInApp" @click="login">登录已有账号丨 </span>
      <span @click="handleContact()">联系客服</span>
    </footer>
    <ContactImg :visible="showContact" @hideVisible="handleContact()" />
    <van-popup
      v-model="vipModalShow"
      @closed="closeVipModal"
      :style="{ borderRadius: '4px', background: 'transparent', top: '45%' }"
    >
      <VipModal :time="vipTime" @closeVipModal="closeVipModal" />
    </van-popup>
    <footer>
      <FooterTab :activeIndex="1" />
    </footer>
    <template v-if="showLogin">
      <ScanLogin @hideVisible="handleScan()" :src="loginQrcode"> </ScanLogin>
    </template>
  </main>
</template>
<script>
import CreateCard from "@/components/createCard";
import SeoLink from "@/components/SeoLink.vue";
import {
  reLogin,
  getToken,
  formatDateTime,
  requestAuth,
  getQueryString,
  handleCode,
  verifyAuth,
  isMobile,
  getWxUrl,
  showServiceAble
} from "@/utils/common";
import ContactImg from "@/components/contactImg";
import VipModal from "@/components/vipModal";
import questionOnly from "@/utils/questionOnly";
import FooterTab from "@/components/footerTab";
import { Toast } from "vant";
import api from "@/utils/api";
import { handleZI, isWeixin } from "../../utils/common";
import ScanLogin from "@/components/scanLogin";
let intervalAsk = null;
let intervalAskCopy = null;
let checkTime = 0;
let checkTimeCopy = 0;

export default {
  components: { CreateCard, ContactImg, FooterTab, ScanLogin, SeoLink, VipModal },
  data() {
    return {
      showLogin: false,
      vipModalShow: false,
      showContact: false,
      vipTime: "",
      funLists: [
        {
          title: "会议破冰，有趣有料",
          desc: "对内、对外会议活动，丰富模板一键选用，高效破冰"
        },
        {
          title: "多种活动类型，满足不同需求",
          desc: "默契问答、在线考试、培训练习、每日一练等多种类型"
        },
        {
          title: "高效出题，录入题目更简单",
          desc: "多端协助管理、多种录入方式、题库管理"
        },
        {
          title: "数据分析，答完即出成绩",
          desc: "成绩排行榜、答题内容详情、错题分析"
        }
      ],
      templateLists: [
        {
          title: "经典IQ测试",
          count: 8,
          joined: 1751,
          qid: "60966e967acaf68a2f33ce33",
          template_id: "5f607466c9328452badafd92"
        },
        {
          title: "水果冷知识，没想到你是这样的水果!",
          count: 10,
          joined: 1211,
          qid: "60966e967acaf68a2f33ce52",
          template_id: "5f6c3acb014de774092eeba3"
        }
        // {
        //   title: "党史知识问答",
        //   count: 5,
        //   joined: 2896,
        //   qid: "62a9bab2864cdffc88eb583b",
        //   template_id: "62a9b922e9839938d8631f38"
        // },
        // {
        //   title: "你和我的默契大考验",
        //   count: 5,
        //   joined: 2029,
        //   qid: "627e1a82f36b801fabfc504a",
        //   template_id: "627e027fe98399382ebc03a4",
        //   type: 5
        // }
      ],
      isInApp: wemeet.app.isTMWebview(),
      meetingInfo: {},
      userInfo: {},
      roleType: 0,
      isMobile: isMobile(),
      isWeixin: isWeixin(),
      wxlistUrl: ""
    };
  },
  methods: {
    async getLoginCode() {
      if (this.isWeixin) {
        reLogin();
      } else {
        if (this.isMobile) {
          if (!this.wxlistUrl) {
            let res = await getWxUrl("pages/createdefault/createdefault", "", 1);
            if (res) {
              this.wxlistUrl = res;
            }
          }
          window.location.href = this.wxlistUrl;
        } else {
          var timestamp = new Date().getTime();
          var myToken =
            timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
          // 获取二维码  开始轮询请求，如果返回ok，清除轮询
          questionOnly
            .get("/xcx/ques_web/v1/qrcode", { token: myToken })
            .then(res => {
              if (res.sta == 0) {
                this.loginQrcode = res.data.qrcode;
                if (!this.showLogin) this.showLogin = true;
                checkTimeCopy = 0;
                this.checkLoginSuccessCopy(myToken);
              } else {
                Toast(res.msg || "请求失败");
              }
            });
        }
      }
    },
    checkLoginSuccessCopy(myToken) {
      clearTimeout(intervalAskCopy);
      checkTimeCopy++;
      if (checkTimeCopy > 20) {
        checkTimeCopy = 0;
        this.getLoginCode();
        return;
      }
      questionOnly
        .get("/xcx/ques_web/v1/check_status", {
          token: myToken,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAskCopy = setTimeout(() => {
              this.checkLoginSuccessCopy(myToken);
            }, 3000);
          } else {
            // 登录成功
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid);
            setTimeout(async () => {
              this.showLogin = false;
              // this.getList();
            }, 100);
          }
        });
    },
    handleScan() {
      if (intervalAskCopy) {
        clearInterval(intervalAskCopy);
        intervalAskCopy = null;
      }
      this.showLogin = !this.showLogin;
    },
    async toCreate() {
      _hmt.push(["_trackEvent", "button_to_createHelp", "click", "新建答题"]);
      if (localStorage.getItem("loginTip")) localStorage.removeItem("loginTip");
      let loginStatus = await verifyAuth();
      if (localStorage.getItem("qid")) localStorage.removeItem("qid");
      if (localStorage.getItem("template_id"))
        localStorage.removeItem("template_id");
      if (!this.isInApp && !this.isMobile) {
        window.location.href = "https://xiaoxiaodati.com/home?clear=1";
        return;
      }
      if (!loginStatus) {
        reLogin();
      } else {
        if (this.isMobile) {
          if (
            !this.isInApp ||
            (this.isInApp && localStorage.getItem("bind_status") == 1)
          ) {
            let url = await getWxUrl();
            window.location.href = url;
          } else {
            // 生成带有绑定参数的url
            this.getAuthInfo();
          }
        } else {
          this.$router.push({ name: "createHelp" });
        }
      }
    },
    getAuthInfo() {
      let param = {
        access_token: getToken(),
        ref_url: window.location.href,
        code_type: 1,
        app_type: api.test ? 1 : 0,
        source: 2
      };
      questionOnly.get("/xcx/ques/v2/meeting/callback", param).then(res => {
        if (res.sta == 0) {
          window.location.href = res.data.url;
          this.checkLoginSuccess(res.data.random_key, res.data.access_token);
        } else if ((res.sta == -1 && res.errcode === 109) || res.sta == -500) {
          Toast("身份已过期请重新授权登录");
          setTimeout(() => {
            requestAuth();
          }, 1000);
        } else {
          Toast(res.msg);
        }
      });
    },
    checkLoginSuccess(random_key, access_token) {
      if (intervalAsk) clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 180 || this.$route.name != "intro") {
        checkTime = 0;
        intervalAsk = null;
        return;
      }
      let parm = {
        random_key,
        access_token,
        app_type: api.test ? 1 : 0,
        loadingMsg: "no"
      };
      questionOnly.get(api.question.checkBindStatus, parm).then(async res => {
        if (res.sta === 0) {
          if (!res.data.status) {
            clearTimeout(intervalAsk);
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(random_key, access_token);
            }, 3000);
          } else {
            this.handleLogined(res.data);
          }
        } else {
          clearTimeout(intervalAsk);
          intervalAsk = null;
          Toast(res.msg);
        }
      });
    },
    handleLogined(data) {
      localStorage.setItem("bind_status", 1);
      if (localStorage.getItem("fail_count"))
        localStorage.removeItem("fail_count");
      localStorage.setItem("token", data.access_token);
      handleZI(data.mp_openid);
    },
    copySuccess() {
      Toast("复制成功");
    },
    closeVipModal() {
      if (this.vipModalShow) {
        this.vipModalShow = false;
      }
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },

    login() {
      if (localStorage.getItem("loginTip")) localStorage.removeItem("loginTip");
      reLogin();
    },
    async toTemplateCenter() {
      if (this.isInApp) {
        this.$router.push({ name: "templateCenter" });
      } else {
        let loginStatus = await verifyAuth();
        if (loginStatus) {
          this.$router.push({ name: "templateCenter" });
        } else {
          this.getLoginCode();
        }
      }
      _hmt.push([
        "_trackEvent",
        "button_to_template",
        "click",
        "templateCenter"
      ]);
    },
    handleTemplateCenterLink() {
      this.toTemplateCenter();
      return false;
    },
    templateDetailRoute(item) {
      let name = item.type === 5 ? "tacitDetail" : "normalDetail";
      return {
        name,
        query: { qid: item.template_id, tempId: item.qid }
      };
    },
    async toTemplateDetail(item) {
      _hmt.push(["_trackEvent", "button_to_template", "click", item.title]);
      if(this.isInApp) {
        this.$router.push(this.templateDetailRoute(item));
      }else {
        let loginStatus = await verifyAuth();
        if (loginStatus) {
          this.$router.push(this.templateDetailRoute(item));
        } else {
          this.getLoginCode();
        }
      }
    },
    handleTemplateDetailLink(item) {
      this.toTemplateDetail(item);
      return false;
    },
    getVipInfo() {
      let param = {
        access_token: getToken() || ""
      };
      questionOnly.get("/xcx/ques/v1/meeting/lead_vip", param).then(res => {
        if (res.sta == 0) {
          let { meet_lead } = res.data;
          if (!meet_lead) {
            this.vipTime =
              formatDateTime(res.data.activity_start * 1000, 3, "/") +
              "-" +
              formatDateTime(res.data.activity_end * 1000, 3, "/");
            let getVipTime = localStorage.getItem("getVipTime");
            if (
              !getVipTime ||
              (getVipTime &&
                (new Date().getTime() - getVipTime) / 1000 > 60 * 360)
            ) {
              this.vipModalShow = true;
              localStorage.setItem("getVipTime", new Date().getTime());
            }
          }
        } else if (res.sta === -1) {
          Toast(res.msg);
        }
      });
    }
  },
  async mounted() {
    document.title = "立吉答题";
    if (!wemeet.app.isTMWebview() && !getToken() && getQueryString("code")) {
      let res = await handleCode(getQueryString("code"));
      if (res) {
        let arr = document.location.toString().split("&code=")[0];
        window.location.replace(arr);
      }
      return;
    }
    if (
      wemeet.app.isTMWebview() &&
      new Date().getTime() > 1656518400000 &&
      new Date().getTime() < 1657209600000
    ) {
      // 腾讯会议获取七天vip
      if (localStorage.getItem("showVipModal")) {
        this.vipModalShow = true;
        localStorage.removeItem("showVipModal");
        localStorage.removeItem("loginTip");
      }
      this.getVipInfo();
    }
    this.meetingInfo = this.$store.state.meetingInfo || {};
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (
      this.isInApp &&
      this.userInfo.openId == this.$store.state.meetingInfo.meet_admin
    ) {
      this.roleType = 1;
    }
  },
  destroy() {
  },
  watch: {
    $route(to) {
      // 监听路由变化, 实现类似 小程序的 onShow 事件
      if (to.path === "/intro") {
        if (localStorage.getItem("qid")) localStorage.removeItem("qid");
        if (localStorage.getItem("template_id"))
          localStorage.removeItem("template_id");
      }
    },
    "$store.state.meetingInfo"() {
      this.meetingInfo = this.$store.state.meetingInfo;
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
main,
section,
article,
header,
footer {
  display: block;
}
h2 {
  margin: 0;
  font: inherit;
  color: inherit;
}
.content {
  padding: 0 0 rem(20);
  box-sizing: border-box;
  color: #262626;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  transition: none;
}
.part {
  background: #fff;
  border-radius: rem(8);
  margin-top: rem(20);
  .title {
    font-weight: 700;
    font-size: rem(34);
    line-height: rem(51);
    display: flex;
    align-items: center;
    justify-content: space-between;
    span, .more-link {
      font-size: rem(28);
      line-height: rem(42);
      color: #999999;
      cursor: pointer;
    }
  }

  .fun-item {
    margin-top: rem(30);
    .intro {
      font-size: rem(30);
      line-height: rem(45);
      color: #000000;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        background: #1890ff;
        width: rem(12);
        height: rem(12);
        border-radius: 50%;
        margin-right: rem(20);
      }
    }
    .desc {
      font-size: rem(24);
      line-height: rem(36);
      color: #999999;
    }
  }
  .template-item {
    display: flex;
    margin-top: rem(20);
    cursor: pointer;
    img {
      width: rem(48);
      height: rem(48);
      margin-right: rem(15);
    }
    .intro {
      font-size: rem(30);
      line-height: rem(45);
      color: #262626;
      margin-bottom: rem(8);
    }
    .desc {
      font-size: rem(24);
      line-height: rem(36);
      color: #999999;
    }
  }
}
.fun {
  padding: rem(30);
  margin-bottom: rem(20);
}
.template {
  padding: rem(20) rem(30);
  margin-bottom: rem(20);
}
.login-btn {
  font-size: rem(24);
  line-height: rem(36);
  color: #999999;
  text-align: center;
  margin-top: rem(30);
  padding-bottom: rem(140);
  span {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/intro/intro.vue